import {useContext, useEffect, useState} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import Autosuggest from '@adv-mt/mt-form-autosuggest'

const USE_CASE = 'get_specs_vehicles_use_case'

const mapOption = ({value, text}) => ({id: value, label: text})
const mapOptions = ({items}) => items.map(mapOption)

const FormModelVersion = ({initialSearch = {}, value = {}, onChange, hasButton}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {FILTER_NAMES} = config.get('search')
  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')
  const {VEHICLE_SPECS_CONTEXT} = config.get('vehicles')
  const {makeId, categoryId} = initialSearch

  const [models, setModels] = useState([])

  useEffect(() => {
    if (!makeId) return
    domain
      .get(USE_CASE)
      .execute({
        nextField: VEHICLE_SPECS_CONTEXT.MODELS_VERSION,
        params: {makeId, categoryId}
      })
      .then(([error, response]) => {
        if (error) return

        const items = mapOptions(response)
        setModels(items)
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryId, makeId])

  const handleChange = (e, {id, value}) => {
    e.preventDefault()
    onChange(e, {
      field: FILTER_NAMES.MODEL,
      value: id ? {id, name: value} : {name: value},
      lastFilter: TRACKING_FILTER_NAMES[FILTER_NAMES.MODEL]
    })
  }

  return (
    <Autosuggest
      label={i18n.t('COMMON.PLURALS.MODEL', 1)}
      id="input-search-filter-model"
      options={models}
      value={value.name}
      onChange={handleChange}
      hasButton={hasButton}
    />
  )
}

FormModelVersion.displayName = 'FormModelVersion'
FormModelVersion.propTypes = {
  initialSearch: PropTypes.shape({
    makeId: PropTypes.number,
    categoryId: PropTypes.number,
    model: PropTypes.string
  }),
  value: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string
  }),
  onChange: PropTypes.func.isRequired,
  hasButton: PropTypes.bool
}

export default FormModelVersion
